// extracted by mini-css-extract-plugin
export default {"contents":"MainScreen_contents__70r5x"};